<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="image-view">
    <div class="scaler">
      <button
        class="scaler__inc"
        @mousedown="isMousePressing = true; mutateScale(scaleStep)"
        @touchstart="isMousePressing = true; mutateScale(scaleStep)"
        @mouseleave="isMousePressing = false"
        @touchend="isMousePressing = false"
        @mouseup="isMousePressing = false"
        v-html="'&plus;'"
      />
      <i-slider
        v-model="scale"
        direction="horizontal"
        :min="minScale"
        :max="maxScale"
        :step="scaleStep"
      />
      <button
        class="scaler__dec"
        @mousedown="isMousePressing = true; mutateScale(-scaleStep)"
        @touchstart="isMousePressing = true; mutateScale(-scaleStep)"
        @mouseleave="isMousePressing = false"
        @touchend="isMousePressing = false"
        @mouseup="isMousePressing = false"
        v-html="'&minus;'"
      />
    </div>
    <div class="wrapper">
      <i-scale-image
        class="viewer"
        :scale.sync="scale"
        :src="tags[index].photo"
      />
      <span
        v-show="tags.length > 1"
        class="arrow left"
        @click="nextTag"
      >
        <i class="isif isif-arrow-left" />
      </span>
      <span
        v-show="tags.length > 1 "
        class="arrow right"
        @click="previousTag"
      >
        <i class="isif isif-arrow-right" />
      </span>
    </div>
  </div>
</template>

<script>
import ISlider from '@/components/ISlider'
import IScaleImage from '@/components/IScaleImage'

export default {
  components: {
    ISlider,
    IScaleImage
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      scaleStep: 0.1,
      scale: 1,
      maxScale: 5,
      minScale: 1,
      isMousePressing: false
    }
  },
  methods: {
    mutateScale (val) {
      if (this.isMousePressing === false) return
      if (this.scale >= this.maxScale && val > 0) return
      if (this.scale <= this.minScale && val < 0) return
      this.scale += val
      setTimeout(() => {
        this.mutateScale(val)
      }, 30)
    },
    nextTag () {
      let index = this.index + 1
      index = index > this.tags.length - 1 ? 0 : index
      this.$emit('update:index', index)
      this.scale = 1
    },
    previousTag () {
      let index = this.index - 1
      index = index < 0 ? this.tags.length - 1 : index
      this.$emit('update:index', index)
      this.scale = 1
    }
  }
}
</script>

<style lang="stylus" scoped>
$gray = #c1c1c1
.image-view {
  display: flex
  flex-direction: row
  width: 600px
  margin: 0 auto
  position: relative
}
.scaler {
  width: 60px
  display: flex
  flex-direction: column
  align-items: center
  user-select: none

  .scaler__inc, .scaler__dec {
    background-color: transparent
    font-size: 35px
    padding: 0 10px
    color: $gray
  }
}
.wrapper {
  width: 100%
  margin-top: 30px
  flex: 1
  position: relative

  &:hover {
    .arrow {
      opacity: 1
    }
  }
  .viewer {
    width: 100%
    height: 100%
  }
  .arrow {
    display: inline-block
    position: absolute
    top: 50%
    font-size: 20px
    width: 25px
    height: 25px
    line-height: 25px
    margin-top: -12px
    cursor: pointer
    text-shadow: 0 0 3px #000
    opacity: 0
    transition: transform .2s ease-out, opacity .1s linear

    &:hover {
      transform: translateX(0) !important
    }
    &.left {
      transform: translateX(5px)
    }
    &.right {
      right: 0
      transform: translateX(-5px)
    }
  }
}
</style>
